import { Image, Container, Row, Col } from 'react-bootstrap';
import Img from '../Img/Pouf/Pouf-banner.jpg';
import CircularGallery from './CircularLitsGallery';
import "./Services.css";

function Lighting() {
    return (
        <>
            <Image className="fade-in responsive-img" src={Img} height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col>
                        <h1 className='text-center my-4 text-decoration-underline'><strong>POUFS</strong></h1>
                        <p style={{ fontSize: '20px' }} className='justify-text'>Discover stylish poufs handcrafted with care from premium materials — including rich textiles, natural fibers, and fine leathers. Available in a range of colors, textures, and finishes, each piece brings comfort, versatility, and a touch of artistry to any living space.</p>
                    </Col>
                </Row>
            </Container>
            <div style={{ height: '600px', position: 'relative' }}>
                <CircularGallery bend={3} borderRadius={0.05} scrollEase={0.02} />
            </div>
        </>
    )
}

export default Lighting